import { motion } from "framer-motion";
import { ShieldCheck, MapPin, Calendar, FileCheck2 } from "lucide-react";

export default function PatentFiled() {
    return (
        <section className="relative py-16 sm:py-24 md:py-32 lg:py-40 border-t border-line overflow-hidden" data-testid="patent-section">
            <div className="absolute inset-0 hero-glow-bg opacity-30 pointer-events-none" />
            <div className="relative max-w-5xl mx-auto px-5 sm:px-6 md:px-10">
                <div className="text-center mb-10 sm:mb-12">
                    <div className="overline mb-4">08 — Institutional Trust</div>
                    <h2 className="font-heading font-black text-[1.85rem] sm:text-4xl lg:text-5xl leading-[1.06] tracking-tight text-ink">
                        Patent Filed.<br />
                        Infrastructure First.<br />
                        <span className="brand-gradient-text">Built for Internet 3.0.</span>
                    </h2>
                    <p className="mt-5 sm:mt-6 text-[15px] sm:text-base text-muted-ink max-w-2xl mx-auto leading-relaxed">
                        DeCloudX has filed a patent for its hybrid decentralized cloud protocol — combining decentralized compute, encrypted distributed storage, Layer-1 blockchain settlement, AI workload routing, on-chain DNS, and developer revenue sharing into one integrated stack.
                    </p>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="brand-gradient-border rounded-3xl"
                    data-testid="patent-certificate"
                >
                    <div className="bg-card rounded-3xl overflow-hidden p-6 sm:p-8 md:p-12 relative">
                        {[
                            "top-4 left-4 border-l border-t",
                            "top-4 right-4 border-r border-t",
                            "bottom-4 left-4 border-l border-b",
                            "bottom-4 right-4 border-r border-b",
                        ].map((c, i) => (
                            <div key={i} className={`absolute w-5 h-5 sm:w-6 sm:h-6 border-brand-cyan/40 ${c}`} />
                        ))}

                        <div className="relative">
                            <div className="flex items-center justify-center gap-2 font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.22em] sm:tracking-[0.3em] text-brand-cyan mb-5 sm:mb-6 text-center">
                                <ShieldCheck size={13} strokeWidth={1.5} className="shrink-0" />
                                <span>DeCloudX Foundation · Filing of Record</span>
                            </div>

                            <div className="text-center">
                                <div className="font-heading font-black text-xl sm:text-2xl md:text-4xl text-ink leading-tight">
                                    Patent Filed Architecture
                                </div>
                                <div className="mt-2 font-heading font-bold text-base sm:text-lg md:text-xl brand-gradient-text">
                                    Hybrid Decentralized Cloud Protocol
                                </div>
                                <div className="mt-3 font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.18em] sm:tracking-[0.22em] text-muted-ink">
                                    DePIN · AI · EVM Chain · Encrypted Storage · On-Chain DNS · Developer Revenue Share
                                </div>
                            </div>

                            <div className="mt-8 sm:mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5 border-t border-line pt-6 sm:pt-8">
                                {[
                                    { icon: FileCheck2, k: "Filed By", v: "DeCloudX Foundation", color: "text-brand-cyan" },
                                    { icon: MapPin, k: "Jurisdiction", v: "Dubai, UAE", color: "text-brand-violet" },
                                    { icon: Calendar, k: "Founded", v: "2020", color: "text-brand-blue" },
                                ].map((it, i) => (
                                    <div key={i} className="flex items-start gap-3">
                                        <div className="w-9 h-9 rounded-lg bg-card border border-line flex items-center justify-center shrink-0 shadow-sm">
                                            <it.icon size={15} className={it.color} strokeWidth={1.5} />
                                        </div>
                                        <div>
                                            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-faint-ink">{it.k}</div>
                                            <div className="text-sm text-ink mt-0.5">{it.v}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-8 pt-6 border-t border-line text-center font-mono text-[10px] uppercase tracking-[0.22em] text-faint-ink">
                                Filing of patent does not constitute granted status · Status: Pending Review
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
